import goldVehicles from './gold-vehicles';
import feedBuilder from './feed-builder';

export default (config) => {
  goldVehicles(config);
  feedBuilder(config);
};



// WEBPACK FOOTER //
// ./src/api-purecars/api-purecars.js